// extracted by mini-css-extract-plugin
export default {"btnStyle":"TokenGenerator_btnStyle__1Lmdp"};